import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { AlertService, BaseService, LocationService } from '@kodit/core/services';
import {
  GetNewIzlaznaFakturaForOtpremnicaQuery, GetNewIzlaznaFakturaForPrijemnicaQuery,
  IzlaznaFakturaDto,
  IzlazneFaktureClient,
  TipRacuna,
  VrstaRacuna
} from '@kodit/core/data-api';
import { Observable } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class IzlaznaFakturaZaEPrijemniceResolver
  extends BaseService
  implements Resolve<IzlaznaFakturaDto> {
  constructor(
    private _client: IzlazneFaktureClient,
    private _router: Router,
    private _locationService: LocationService,
    private _alertService: AlertService) {
    super();
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<IzlaznaFakturaDto>
    | Promise<IzlaznaFakturaDto>
    | IzlaznaFakturaDto
    | null {

    if(!this._router.getCurrentNavigation().extras.state){
      this._locationService.routeToRacunTable(TipRacuna.IZLAZNA_FAKTURA, VrstaRacuna.EMPTY);
    }
    return this._client
      .getNewForEPrijemnica(
        new GetNewIzlaznaFakturaForPrijemnicaQuery({
          prijemnicaIdArray: this._router.getCurrentNavigation().extras.state.otpremnicaIdArray,
        })
      )
      .pipe(
        map((res) => {
          if (!res.succeeded) {
            this._alertService.addWarnMsgs(res.messages);
            this._router.navigate(['/eotpremnice', 'slanje-robe']);
            return null;
          }
          return res.data;
        }),
        catchError(this.handleError),
        finalize(() => {
          //this._configService.setIsBusy = false;
        })
      );
  }
}
